const cards = [
  {
    title: '奔跑吧·生态篇收官',
    desc: '收官之战全员集结，终极任务悬念揭晓，本季最感人名场面全记录。',
    tag: '户外竞技',
    img: 'https://readdy.ai/api/search-image?query=An%20outdoor%20adventure%20game%20show%20scene%20with%20colorful%20team%20jerseys%20and%20obstacles%2C%20bright%20sunny%20day%2C%20green%20nature%20background%2C%20dynamic%20sports%20atmosphere%2C%20warm%20vibrant%20colors%2C%20entertainment%20production%20style%2C%20no%20visible%20faces&width=400&height=280&seq=card-01-51movies&orientation=landscape',
  },
  {
    title: '极限挑战宝藏行',
    desc: '极限男人帮开启全新宝藏之旅，脑洞大开的任务设计让笑点与悬念齐飞。',
    tag: '户外挑战',
    img: 'https://readdy.ai/api/search-image?query=A%20treasure%20hunt%20themed%20adventure%20scene%20with%20ancient%20map%20aesthetic%2C%20warm%20golden%20hour%20lighting%2C%20mysterious%20chest%20props%2C%20outdoor%20exploration%20atmosphere%2C%20cinematic%20composition%2C%20amber%20and%20gold%20tones%2C%20no%20people&width=400&height=280&seq=card-02-51movies&orientation=landscape',
  },
  {
    title: '乘风2024二公舞台',
    desc: '第二次公演舞台全面升级，姐姐们突破自我挑战全新风格，惊艳全场。',
    tag: '音乐竞演',
    img: 'https://readdy.ai/api/search-image?query=A%20grand%20music%20performance%20stage%20with%20dramatic%20coral%20red%20and%20golden%20spotlights%2C%20elegant%20stage%20curtains%2C%20professional%20concert%20lighting%20rig%2C%20theatrical%20atmosphere%2C%20warm%20intense%20tones%2C%20no%20visible%20people&width=400&height=280&seq=card-03-51movies&orientation=landscape',
  },
  {
    title: '向往的生活·海岛篇',
    desc: '蘑菇屋搬到了海边小岛，慢综艺天花板带来治愈心灵的温暖故事。',
    tag: '生活慢综',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20seaside%20wooden%20cottage%20with%20warm%20evening%20lighting%2C%20string%20lights%2C%20outdoor%20dining%20table%20set%20with%20fresh%20food%2C%20ocean%20view%20in%20background%2C%20peaceful%20sunset%20atmosphere%2C%20warm%20amber%20and%20golden%20tones&width=400&height=280&seq=card-04-51movies&orientation=landscape',
  },
  {
    title: '脱口秀大会新赛季',
    desc: '新老选手同台竞技，金句频出笑翻全场。谁能成为本季脱口秀大王？',
    tag: '喜剧脱口秀',
    img: 'https://readdy.ai/api/search-image?query=A%20standup%20comedy%20stage%20with%20a%20single%20microphone%20stand%20under%20warm%20spotlight%2C%20brick%20wall%20background%2C%20intimate%20club%20atmosphere%2C%20red%20curtain%2C%20warm%20amber%20lighting%2C%20professional%20comedy%20show%20setting%2C%20no%20people&width=400&height=280&seq=card-05-51movies&orientation=landscape',
  },
  {
    title: '密室大逃脱·古堡谜案',
    desc: '全新古堡主题密室，烧脑谜题层层递进，紧张氛围拉满的沉浸式逃脱体验。',
    tag: '悬疑推理',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20ancient%20castle%20room%20interior%20with%20dim%20warm%20candlelight%2C%20stone%20walls%2C%20wooden%20furniture%2C%20mysterious%20atmosphere%2C%20escape%20room%20setting%20with%20puzzles%20and%20clues%2C%20warm%20amber%20glow%2C%20cinematic%20mood&width=400&height=280&seq=card-06-51movies&orientation=landscape',
  },
  {
    title: '天赐的声音·巅峰之夜',
    desc: '音乐合伙人强强联手，经典金曲全新改编，天籁之音震撼心灵的音乐盛宴。',
    tag: '音乐综艺',
    img: 'https://readdy.ai/api/search-image?query=A%20spectacular%20music%20show%20finale%20stage%20with%20golden%20confetti%20falling%2C%20dramatic%20warm%20spotlights%2C%20large%20LED%20screen%20displaying%20music%20visualization%2C%20grand%20concert%20atmosphere%2C%20amber%20and%20gold%20tones%2C%20celebration%20mood%2C%20no%20visible%20people&width=400&height=280&seq=card-07-51movies&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              综艺精选
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              本周热门综艺推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              精选本周最受瞩目的综艺节目，总有一档适合你的口味
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {cards.slice(0, 3).map((card) => (
              <div
                key={card.title}
                className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all group cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mt-5 md:mt-6">
            {cards.slice(3).map((card) => (
              <div
                key={card.title}
                className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all group cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}